import { PdfTemplate, TableSorting } from "components";
import { cellValuePdf, RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { DataType } from "../types";

export function ExportPdfRequestForm(props: {
    data: DataType[],
    tableActive: TableSorting[]
}) {

   const activeCols = props.tableActive.filter(col => col.isActive !== false)

    const columns = [
        { header: "NO", key: "no", width: 5 },
        ...activeCols
            .map(col => renderColumn(col.value as string))
            .filter((col): col is NonNullable<typeof col> => col !== undefined),
    ]

    const dataMap = props.data.map((item, index) => {
        const row: Record<string, any> = { no: index + 1 }

        activeCols.forEach(col => {
            const colMeta = renderColumn(col.value as string)
            if (colMeta) {
                row[colMeta.key] = renderCellValue(col.value as string, item)
            }
        })

        return row
    })

    return (
        <PdfTemplate 
            data={dataMap} 
            module="INVENTORY" 
            title="ITEM REQUEST FORM" 
            column={columns} 
        />
    )
}

function numberFormat(value: number): cellValuePdf {
    return {
        text: convertNumber(value).intoCurrency,
        style: {
            textAlign: "right",
            fontWeight: "bold"
        }
    }
}


function renderColumn(title: string): { header: string; key: string | number; width: number } | undefined {
    const map: Record<string, { header: string; key: keyof RowExportTypePdf; width: number }> = {
        "item_code": { header: "ITEM CODE", key: "product_code", width: 20 },
        "barcode": { header: "BARCODE", key: "product_barcode", width: 20 },
        "build": { header: "BUILD", key: "build_item", width: 10 },
        "description": { header: "DESCRIPTION", key: "product_name", width: 30 },
        "unit": { header: "UNIT", key: "mr_unit_name", width: 15 },
        "soh": { header: "SOH", key: "soh", width: 15 },
        "on_order": { header: "ON ORDER", key: "back_order", width: 15 },
        "commit": { header: "COMMITED", key: "commited", width: 15 },
        "available": { header: "AVAILABLE", key: "available", width: 15 },
    }
    return map[title]
}

function simbolFormat(value: boolean): cellValuePdf {
    return {
        text: value ? '\uf00c' : '',
        style: {textAlign: "center", fontFamily: "FontAwesome"}, 
    }
}

function renderCellValue(title: string, item: any): any {
    switch (title) {
        case "item_code":
            return item.product_code
        case "barcode":
            return item.product_barcode
        case "build":
            return simbolFormat(item.build_item)
        case "description":
            return item.product_name
        case "unit":
            return item.mr_unit_name
        case "soh":
            return numberFormat(Number(item.soh))
        case "on_order":
            return numberFormat(Number(item.back_order))
        case "commit":
            return numberFormat(Number(item.commited))
        case "available":
            return numberFormat(Number(item.available))
        default:
            return item
    }
}